import { styled as styledMui, Box, Button, IconButton } from "@mui/material";

export const CardRow = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "16px 20px",
  borderRadius: "12px",
  backgroundColor: theme.palette.background.card || "#2A2A2A",
  border: "1px solid transparent",
  transition: "border-color 0.15s ease",
  "&:hover": {
    borderColor: theme.palette.divider,
  },
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: "12px",
  },
}));

export const CheckboxArea = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
});

export const IconArea = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "24px",
  height: "24px",
  color: theme.palette.text.primary,
}));

export const InfoArea = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  flex: 1,
  minWidth: 0,
});

export const MetricsWrapper = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "0px",
});

export const TitleRow = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

export const MetricsRow = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  flexWrap: "wrap",
  [theme.breakpoints.down("lg")]: {
    gap: "16px",
  },
}));

export const MetricItem = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontSize: "12px",
  color: theme.palette.text.description,
  "& svg": {
    width: "14px",
    height: "14px",
    color: theme.palette.text.tertiary,
  },
  [theme.breakpoints.down("lg")]: {
    whiteSpace: "nowrap",
  },
}));

export const MetricClickable = styledMui(Box)(({ theme }) => ({
  cursor: "pointer",
  textDecoration: "underline",
  textDecorationColor: theme.palette.text.tertiary,
  textUnderlineOffset: "2px",
  "&:hover": {
    color: theme.palette.text.primary,
  },
}));

export const MetricSeparator = styledMui(Box)(({ theme }) => ({
  width: "1px",
  height: "12px",
  backgroundColor: theme.palette.divider,
  margin: "0 4px",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

export const RightArea = styledMui(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  justifyContent: "space-between",
  flexShrink: 0,
  alignSelf: "stretch",
  gap: "12px",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
    alignItems: "stretch",
  },
}));

export const BadgesRow = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  [theme.breakpoints.down("lg")]: {
    justifyContent: "flex-start",
  },
}));

export const ActionsRow = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexWrap: "wrap",
  [theme.breakpoints.down("lg")]: {
    justifyContent: "flex-start",
  },
}));

export const ActionBtn = styledMui(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: "6px 20px",
  fontSize: "13px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
  lineHeight: 1.5,
  borderColor: theme.palette.text.primary,
  color: theme.palette.text.primary,
  "&:hover": {
    borderColor: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
  },
}));

export const MoreBtn = styledMui(IconButton)(({ theme }) => ({
  width: "36px",
  height: "36px",
  border: `2px solid ${theme.palette.text.primary}`,
  borderRadius: "8px",
  color: theme.palette.text.primary,
  "&:hover": {
    borderColor: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
  },
}));

export const IconActionBtn = styledMui(IconButton)(({ theme }) => ({
  width: "36px",
  height: "36px",
  border: `2px solid ${theme.palette.text.primary}`,
  borderRadius: "8px",
  color: theme.palette.text.primary,
  "&:hover": {
    borderColor: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
  },
}));

export const PublishBtn = styledMui(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: "6px 20px",
  fontSize: "13px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
  lineHeight: 1.5,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    boxShadow: "none",
  },
}));
